module.exports = __webpack_public_path__ + "static/media/portfolio6.95ea14a5.webp";